import { ROUTER_PATHS } from "@/shared";
import { useFetchGetByIdCuadreInventario } from "@/shared/actions/erp/inventario/cuadre.actions";
import { LoaderComponent } from "@/shared/components/ui";
import { Navigate, useParams } from 'react-router-dom';
import SaveCuadreInventario from "../../shared/componente/save-cuadre-inventario/SaveCuadreInventario";



export default function EditCuadreInventarioPage() {

  const { id } = useParams();

  const {
    data,
    isLoading
  } = useFetchGetByIdCuadreInventario(id!);


  if (isLoading) {
    return <LoaderComponent />
  }

  if (!data) {
    return <Navigate to={ROUTER_PATHS.inventario.cuadreInventarioNav} />
  }

  return (
    <SaveCuadreInventario
      label="📝 Borrador Cuadre de Inventario"
      editCuadre={data.data}
    />
  )

}